<template>
    <div>
        <StatusTrack
            v-if="trackerSections.length"
            :sections="trackerSections"
            :is-completed="sectionsCompleted === sectionsToComplete"
            :show-helper="showHelper"
            @save="$emit('saveExit')"
            @next="$emit('saveNext', 3)"
        />

        <SectionInverter
            v-for="(inverter, index) in data"
            :key="index"
            :item="index"
            :heading="inverter.heading"
            :data.sync="data[index]"
            :validated.sync="validated[index]"
            :class="{ 'mt-lg': index !== 0 }"
            @status="trackStatus"
        />

        <div class="commissioning-sheet__btn">
            <button class="btn mt-xl mr-xs" @click="$emit('saveExit')">Save and exit</button>
            <button class="btn mt-xl" @click="$emit('saveNext', 3)">Continue</button>
        </div>
    </div>
</template>
<script>
/* eslint-disable no-console */
import SectionInverter from './SectionInverter';
import StatusTrack from './StatusTrack';

export default {
    components: {
        SectionInverter,
        StatusTrack
    },

    props: {
        commissioningSheet: {
            type: Object,
            required: true,
        },
        showHelper: {
            type: Boolean,
            default: true
        },
    },

    data() {
        return {
            validated: [],
            trackerSections: [],
            sectionsToComplete: this.commissioningSheet.inverters.length,
            data: this.commissioningSheet.inverters,
        }
    },

    computed: {
        sectionsCompleted() {
            return this.validated.filter(item => item === true).length;
        },
    },

    watch: {
        sectionsCompleted() {
            this.$emit('validateStep', 1 , this.sectionsCompleted === this.sectionsToComplete);
        }
    },

    mounted() {
        document.body.scrollTop = 0;

        const validated = [];
        this.data.map(() => {
            validated.push(false);
        });

        this.validated = validated;

        this.$emit('validateStep', 1 , this.sectionsCompleted === this.sectionsToComplete);


        // Create sections for the status tracker

        const sections = [];
        this.data.map((inverter, index) => {
            sections.push({
                title: inverter.heading,
                id: `#inverter${index}`,
                completed: 0,
                toComplete: 6,
            });
        });

        this.trackerSections = sections;
    },

    methods: {
        trackStatus(number, item) {
            this.trackerSections[item].completed = number;
        }
    },
}
</script>
